//api doc users
//https://developer.genesys.cloud/useragentman/users/
//api doc for authentication 

import { getMyProfile } from "../store/auth/auth-actions";

//https://developer.genesys.cloud/authorization/platform-auth/guides/oauth/
const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const BASE_URL_API_V2 = `${BASE_URL}/api/v2`;
const PAGE_SIZE=process.env.REACT_APP_API_PAGE_SIZE;
const PAGE_SIZE_USER_SEARCH=process.env.REACT_APP_API_PAGE_SIZE_USER_SEARCH;

const SKILL_FILTER=process.env.REACT_APP_SKILL_FILTER; 
const LANGUAGE_FILTER=process.env.REACT_APP_LANGUAGE_FILTER; 
const USER_FILTER=process.env.REACT_APP_USER_FILTER;
const QUEUE_FILTER= process.env.REACT_APP_QUEUE_FILTER;
const GROUP_EXCLUSION_FILTER=process.env.REACT_APP_GROUP_EXCLUSION_FILTER; 
const GROUP_INCLUSION_FILTER=process.env.REACT_APP_GROUP_INCLUSION_FILTER;
const INCLUDE_ROLE_ENABLED_GROUPS=process.env.REACT_APP_INCLUDE_ROLE_ENABLED_GROUPS === 'true';
const SKILLGROUPS_FILTER=process.env.REACT_APP_SKILLGROUP_FILTER; 
const PROFILE_SECTION_SAVED_FILTERS=process.env.REACT_APP_PROFILE_SECTION_SAVED_FILTERS ? process.env.REACT_APP_PROFILE_SECTION_SAVED_FILTERS : "*" ; 
const PROFILE_FIELD_SAVED_FILTERS=process.env.REACT_APP_PROFILE_FIELD_SAVED_FILTERS; 


export async function fetchMyProfile(token, signal) {

  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users/me`,
    parseError: (json) => {
      const error = new Error("Failed to get my profile");
      return error;
    },
    method: "GET",
    token: token,
    signal: signal
  });
}

//Uses deprecated API - no other way possible currently - Cloud itself also uses the deprecated api
export async function fetchSavedFilters(token, userId, signal){
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users/${userId}/profile?fl=${PROFILE_SECTION_SAVED_FILTERS}`,
    convertJson: (json) => {
      console.log("Fetching Saved Filters");
      if(!PROFILE_FIELD_SAVED_FILTERS) return [];

      if(!json[PROFILE_SECTION_SAVED_FILTERS]) return [];

      let profileSection = json[PROFILE_SECTION_SAVED_FILTERS];

      if(!profileSection[PROFILE_FIELD_SAVED_FILTERS]) return [];

      let savedFiltersString = profileSection[PROFILE_FIELD_SAVED_FILTERS][0].value;

      if(!savedFiltersString) return [];

      return JSON.parse(savedFiltersString);
    },
    parseError: (json) => {
      const error = new Error("Failed to get my saved filters");
      return error;
    },
    method: "GET",
    token: token,
    signal: signal
  });
}


export async function fetchTeams(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/teams?sortOrder=ascending&pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      return json.entities;
/*      
      if (!USER_FILTER) return json.entities;
      return json.entities.filter(user => user && user.name.startsWith(USER_FILTER));
*/
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the users");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchDivisions(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/authorization/divisions?sortOrder=ascending&pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      return json.entities;
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the divisions");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchUsers(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users?expand=skills,languages&sortOrder=ascending&pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!USER_FILTER) return json.entities;
      return json.entities.filter(user => user && user.name.startsWith(USER_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the users");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchGroups(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/groups?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      /* Roles enabled groups have to be excluded according to Steef (11/04/2024) */
      /* Make that exclusion configurable (HRS - Sander Kaldenhoven - 16/07/2024) */

      let result = json.entities;

      if(!INCLUDE_ROLE_ENABLED_GROUPS){
        result = result.filter(group => group && !group.rolesEnabled);
      }

      if(GROUP_EXCLUSION_FILTER){
        result = result.filter(group => group && !group.name.startsWith(GROUP_EXCLUSION_FILTER));
      }

      if(GROUP_INCLUSION_FILTER){
        result = result.filter(group => group && group.name.startsWith(GROUP_INCLUSION_FILTER));
      }

      return result;
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the groups");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchGroupMembers(token, groupId, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/groups/${groupId}/members?expand=skills,languages,employerInfo&sortOrder=ascending&pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
//     if (!GROUP_FILTER) return json.entities;
//     console.log("GROUP FILTER");
//     return json.entities.filter(group => group && group.name.startsWith(GROUP_FILTER));
      return json.entities;
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the group members");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

/*

const searchCriteria = {
    groups : [],        //UserGroups <-> Skill expression Groups ?
    users : [],
    queues : [],           //Queue membership
    queueActivations : [], //Queue activation
    departments : [],
    skills : [],         //Having skill <-> skill level/proficiency ?
    languages : [], 
    teams : [],
    userStatus = '',
    users : [],
    departments : [],
    divisions : [],
}
*/

export async function searchUsers(token, searchCriteria, signal){

  //To make this work: 
  //  1) Fetch users from skill groups (if in criteria)
  //  2) Merge if multiple (keep common elements only)
  //  3) Add resulting users as user id's in the search Criteria to get expands (skills, languages, ...) and apply additional filters
  let newSearchCriteria = {...searchCriteria};
  
  let sgResult = null;
  if(searchCriteria.skillGroups){
     for(const skillGroup of searchCriteria.skillGroups){
      let sgResultLoop = await searchSkillGroupMembers(token, skillGroup);
      
      if(!sgResult){
        sgResult = sgResultLoop;
      } else {
        let previousResults = sgResult;

        sgResult = sgResultLoop.filter(searchUserResult => previousResults.find((member) => member.id === searchUserResult.id));;
      }
    }
  }


  if(sgResult){
    //Need to add users to searchCriteria
    if(!newSearchCriteria.users){
      newSearchCriteria.users = sgResult;
    }
  }
  
  return await searchUsersApi(token, newSearchCriteria, signal);
}

export async function searchUsersApi(token, searchCriteria, signal){
  console.log("Searching using api");
  if(!searchCriteria 
        || (
              (!searchCriteria.groups || !searchCriteria.groups.length) &&
//              (!searchCriteria.skillGroups || !searchCriteria.skillGroups.length) &&
              (!searchCriteria.skills || !searchCriteria.skills.length) &&
              (!searchCriteria.languages || !searchCriteria.languages.length) &&
              (!searchCriteria.queues || !searchCriteria.queues.length) &&
              (!searchCriteria.queueActivations || !searchCriteria.queueActivations.length) &&
              (!searchCriteria.teams || !searchCriteria.teams.length) &&
              (!searchCriteria.users || !searchCriteria.users.length) &&
              (!searchCriteria.departments || !searchCriteria.departments.length) &&
              (!searchCriteria.divisions || !searchCriteria.divisions.length) &&
              (!searchCriteria.userStatus)
        )
    ) {
    return;
  }

  //TODO: make sure below is only executed when a filter (exept skillgroups) 

  let searchedUsers = await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users/search`,
    generateBody: () => {
      if(!searchCriteria) return {};
      
      let body = {
          pageSize: PAGE_SIZE_USER_SEARCH,
          pageNumber: 1,
          sortOrder: "ASC",
          sortBy: "name",
          expand: [
            "languages",
            "groups",
            "skills",
            "employerInfo"
          ]
      };

      let queries = [];

      if(searchCriteria.groups && searchCriteria.groups.length > 0){
        queries = queries.concat(
          searchCriteria.groups.map(group => { return {
                  type: "EXACT",
                  operator: "AND",
                  fields: [
                    "groups.official.id",
                    "groups.social.id",
                    "groups.distribution.id"
                  ],
                  value: group.id
                }
            })
        );
      }
      
      if(searchCriteria.skills && searchCriteria.skills.length > 0){
        console.log("SearchForUsers - with skills");
        queries = queries.concat(
          searchCriteria.skills.map(skill => { return {
                  type: "EXACT",
                  operator: "AND",
                  fields: [
                    "routingSkills.guid",
                  ],
                  value: skill.id
                }
            })
        );
      }

      if(searchCriteria.languages && searchCriteria.languages.length > 0){
        console.log("SearchForUsers - with languages");
        queries = queries.concat(
          searchCriteria.languages.map(language => { return { 
                  type: "EXACT",
                  operator: "AND",
                  fields: [
                    "languages.guid",
                  ],
                  value: language.id
                }
            })
        );
      }

      if(searchCriteria.queues && searchCriteria.queues.length > 0){
        console.log("SearchForUsers - with queues");
        queries = queries.concat(
          searchCriteria.queues.map(queue => { return {
                type: "EXACT",
                operator: "AND",
                fields: [
                  "queueMembership.added",
                ],
                value: queue.id
              }
            })
        );
      }

      if(searchCriteria.queueActivations && searchCriteria.queueActivations.length > 0){
        console.log("SearchForUsers - with queue activations");
        queries = queries.concat(
          searchCriteria.queueActivations.map(queue => { return {
                type: "EXACT",
                operator: "AND",
                fields: [
                  "queueMembership.joined",
                ],
                value: queue.id
              }
            })
        );
      }

      if(searchCriteria.teams && searchCriteria.teams.length > 0){
        console.log("SearchForUsers - with teams");
        queries = queries.concat(
          searchCriteria.teams.map(team => { return {
                type: "EXACT",
                operator: "AND",
                fields: [
                  "teamId",
                ],
                value: team.id
              }
           })
        );
      }

      if(searchCriteria.departments && searchCriteria.departments.length > 0){
        console.log("SearchForUsers - with departments");
        queries = queries.concat(
          searchCriteria.departments.map(department => { return {
                type: "EXACT",
//                type: "CONTAINS",
                operator: "AND",
                fields: [
                  "department",
                ],
                value: department
              }
           })
        );
      }

      if(searchCriteria.divisions && searchCriteria.divisions.length > 0){
        console.log("SearchForUsers - with divisions");
        queries = queries.concat(
          searchCriteria.divisions.map(division => { return {
                type: "EXACT",
                operator: "AND",
                fields: [
                  "divisionId",
                ],
                value: division.id
              }
           })
        );
      }

      //Don't think it makes a lot of sense to have AND relations and multiple users - won't return anybody. 
      //Also don't think it's usefull to have AND relations between this and all other searches that option is already available using the column filters on the grid
      if(searchCriteria.users && searchCriteria.users.length > 0){
        console.log("SearchForUsers - with users");
/*        
        queries = queries.concat(
          searchCriteria.users.map(user => { return {
                type: "EXACT",
                operator: "AND",
                fields: [
                  "id",
                ],
                value: user.id
              }
           })
        );
*/
        queries = queries.concat( {
          type: "EXACT",
          operator: "OR",
          fields: [
            "id",
          ],
          values: 
              searchCriteria.users.map(user => {
                return user.id;
              })
        });
      }

      if(searchCriteria.userStatus){
        console.log("SearchForUsers - with user status");
        queries = queries.concat(
          {
            type: "EXACT",
            operator: "AND",
            fields: [
              "state",
            ],
            value: searchCriteria.userStatus
          }
        );
      }

      body.query = queries;
//console.log(body);

      return body;
    },
    convertJson: (json) => {
      if (!json.results) return [];
      //More filtering if/when needed (for what's not possible/easy in search api)

      return json.results;
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the group members");
      return error;
    },
    pageNumber: 1,  //Place to store the pageNumber between requests if result > pageSize
    method: "POST",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });


  //Skill groups -> members cannot be fetched through search api. Fetch seperately & merge results
  let result = await searchSkillGroupMembers(token, searchCriteria.skillGroups, signal);

  if(searchCriteria.skillGroups && searchCriteria.skillGroups.length > 0){
    
/*
    await searchCriteria.skillGroups.forEach( async (skillGroup) => {
      let members = await makeJsonRequest({
        generateUrl: () => `${BASE_URL_API_V2}/routing/skillgroups/${skillGroup.id}/members?expand=entities&pageSize=${PAGE_SIZE}`,
        convertJson: (json) => {
          if (!json.entities) return [];
          return json.entities;
        },
        parseError: (json, skillGroupId) => {
          const error = new Error(`An error occurred while trying to fetch the skill group members: ${json.message}`);
          return error;
        },
        method: "GET",
        baseUrl: BASE_URL,
        mergeResult : (list, json) => {
          return list ? list.concat(json): json;
        },
        token: token,
        signal: signal
      }, skillGroup);
      
      if(members && members.entries){
        //Merge results & members - only keep entries in both

        console.log("+result+");
        console.log(result);

        let commonElements = result.filter(searchUserResult => members.find((member) => member.id === searchUserResult.id));
        result = commonElements;

        console.log("commonElements");
        console.log(commonElements);
        console.log("-result-");
        console.log(result);
        
      }
    });
*/
  console.log("Returning result");

//    return result;
  } else {
    console.log("Returning searched Users");
//    return searchedUsers;
  }

  return searchedUsers;
}

export async function searchSkillGroupMembers(token, skillGroup, signal){
  console.log("TEST searchSkillGroupMembers");

  let result = [];
  if(!skillGroup || !skillGroup.id) return result;

  console.log("TEST searchSkillGroupMembers 2");

  let skillGroupMembers = await fetchSkillGroupMembers(token, skillGroup.id, signal);

  if(skillGroupMembers){
    console.log("TEST searchSkillGroupMembers 4");
    if(result.length === 0){ 
        result = skillGroupMembers
    } else {

      let commonElements = result.filter(searchUserResult => skillGroupMembers.find((member) => member.id === searchUserResult.id));
      result = commonElements;

      console.log("commonElements");
      console.log(commonElements);
      console.log("-result-");
      console.log(result);
    }
  }

  return result;
}


export async function searchUsersByName(token, name, signal){
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/users/search?expand=skills,languages,employerInfo&sortOrder=ascending&pageSize=${PAGE_SIZE}`,
    generateBody: () => {
      if(!name) return {};

      
      let body = {
          sortOrder: "ASC",
          sortBy: "name",
          expand: [
            "languages",
            "groups",
            "skills",
            "employerInfo"
          ]
      };

      body.query = [
        {
          "fields": ["state"],
          "values": ["active"],
          "type": "EXACT",
          "operator": "OR"
        },
        {
            "group": [
                {
                    "type": "CONTAINS",
                    "fields": ["name"],
                    "value": name,
                    "operator": "OR"
                },
                {
                    "type": "QUERY_STRING",
                    "fields": ["name"],
                    "value": name,
                    "operator": "OR"
                }
            ]
        }  
      ];

      return body;
    },
    convertJson: (json) => {
      if (!json.results) return [];
      //More filtering if/when needed (for what's not possible/easy in search api)
console.log("Searched users by name");
console.log(json.results)
      return json.results;
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the group members");
      return error;
    },
    method: "POST",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchSkills(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skills?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!SKILL_FILTER) return json.entities;
      return json.entities.filter(skill => skill && skill.name.startsWith(SKILL_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the skills");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchSkillGroups(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skillgroups?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!SKILLGROUPS_FILTER) return json.entities;
      return json.entities.filter(skillGroup => skillGroup && skillGroup.name.startsWith(SKILLGROUPS_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the skill groups");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchSkillGroup(token, skillGroupId, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skillgroups/${skillGroupId}`,
    convertJson: (json) => {
//      if (!json.entities) return [];
      return json;
    },
    parseError: (json, skillGroupId) => {
      const error = new Error(`An error occurred while trying to fetch the skill group members: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
/*    
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
*/
    token: token,
    signal: signal
  }, skillGroupId);
}


export async function fetchSkillGroupDivisions(token, skillGroupId, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skillgroups/${skillGroupId}/members/divisions?expand=entities`,
    convertJson: (json) => {
      if (!json.entities) return [];
      return json.entities;
    },
    parseError: (json, skillGroupId) => {
      const error = new Error(`An error occurred while trying to fetch the skill group divisions: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  }, skillGroupId);
}


export async function fetchSkillGroupMembers(token, skillGroupId, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/skillgroups/${skillGroupId}/members?expand=entities&pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      return json.entities;
    },
    parseError: (json, skillGroupId) => {
      const error = new Error(`An error occurred while trying to fetch the skill group members: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  }, skillGroupId);
}

export async function fetchLanguages(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/languages?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!LANGUAGE_FILTER) return json.entities;
      return json.entities.filter(skill => skill && skill.name.startsWith(LANGUAGE_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the languages");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

export async function fetchQueues(token, signal) {
  return await makeJsonRequest({
    generateUrl: () => `${BASE_URL_API_V2}/routing/queues?pageSize=${PAGE_SIZE}`,
    convertJson: (json) => {
      if (!json.entities) return [];
      if (!QUEUE_FILTER) return json.entities;
      return json.entities.filter(queue => queue && queue.name.startsWith(QUEUE_FILTER));
    },
    parseError: (json) => {
      const error = new Error("An error occurred while trying to fetch the queues");
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      return list ? list.concat(json): json;
    },
    token: token,
    signal: signal
  });
}

//Page Sizes of max 100 - others: max 500
export async function fetchQueueMembers(token, queues, signal) {
  return await makeMultipleJsonRequests({
    generateUrl: queue => `${BASE_URL_API_V2}/routing/queues/${queue.id}/members?pageSize=${PAGE_SIZE}`,
    convertJson: (json, queue) => {
      return {queueId: queue.id, members: json.entities};
    },
    parseError: (json, queue) => {
      const error = new Error(`An error occurred while trying to fetch the skill levels: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (queueMembers, json) => {
      if (!queueMembers) return json;
      if (!queueMembers.members) queueMembers.members = [];
      if (!json) return queueMembers;
      if (!json.members) return queueMembers;
      queueMembers.members = queueMembers.members.concat(json.members);
      return queueMembers
    },
    token: token,
    signal: signal
  }, queues);
}

export async function patchQueueMembers(token, queueMembersList) {
  await doPatchQueueMembers(token, queueMembersList, true);
  await doPatchQueueMembers(token, queueMembersList, false);
}

export async function doPatchQueueMembers(token, queueMembersList, isDelete) {
  return await makeMultipleJsonRequests({
    generateUrl: queueMembers => `${BASE_URL_API_V2}/routing/queues/${queueMembers.queueId}/members?delete=${isDelete}`,
    generateBody: queueMembers => {
      const workingMembers = isDelete ? queueMembers.membersToDelete : queueMembers.membersToAdd;
      if (!workingMembers) return;

      return workingMembers.map(member => { 
        return {
            id: member.id, 
          };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to add members to the queue: ${json.message}`);
      return error;
    },
    validateEntity: (queueMembers) => {
      if (!queueMembers) return false;
      const workingMembers = isDelete ? queueMembers.membersToDelete : queueMembers.membersToAdd;
      return workingMembers && workingMembers.length;
    },
    method: "POST",
    token: token
  }, queueMembersList);
}

export async function doPatchQueueActivations(token, queueActivationsList){
  return await makeMultipleJsonRequests({
    generateUrl: queueActivations => `${BASE_URL_API_V2}/routing/queues/${queueActivations.queueId}/members`,
    generateBody: queueActivations => {
      if (!queueActivations.members) return;

      return queueActivations.members.map(activation => { 
        return {
            id: activation.id, 
            joined: activation.joined
          };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to add members to the queue: ${json.message}`);
      return error;
    },
    validateEntity: (queueActivations) => {
      if (!queueActivations) return false;
      return queueActivations.members && queueActivations.members.length;
    },
    method: "PATCH",
    token: token
  }, queueActivationsList);
}



/* No longer used - skill levels are included in users and group members calls
export async function fetchSkillLevels(token, users, signal) {
  
  return await makeMultipleJsonRequests({
    generateUrl: user => `${BASE_URL_API_V2}/users/${user.id}/routingskills?pageSize=${PAGE_SIZE}`,
    convertJson: (json, user) => {
      return {userId: user.id, skillLevels: json.entities};
    },
    parseError: (json, user) => {
      const error = new Error(`An error occurred while trying to fetch the skill levels: ${json.message}`);
      return error;
    },
    method: "GET",
    baseUrl: BASE_URL,
    mergeResult : (list, json) => {
      if (!list) return json;
      if (!list.skillLevels) list.skillLevels = [];
      if (!json) return list;
      if (!json.skillLevels) return list;
      list.skillLevels = list.skillLevels.concat(json.skillLevels);
      return list;
    },
    token: token,
    signal: signal
  }, users);
}
*/
export async function patchSkillLevels(token, skillLevels) {
  await doDeleteUserSkills(token, skillLevels);
  await doPatchSkillLevels(token, skillLevels);
}


export async function doPatchSkillLevels(token, skillLevels) {
  return await makeMultipleJsonRequests({
    generateUrl: userLevels => `${BASE_URL_API_V2}/users/${userLevels.userId}/routingskills/bulk`,
    generateBody: userLevels => {
      return userLevels.skillLevels.map(skillLevel => { 
        return {
          id: skillLevel.id, 
          proficiency : skillLevel.proficiency
        };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to patch the skill levels: ${json.message}`);
      return error;
    },
    method: "PATCH",
    token: token
  }, skillLevels);
}

export async function patchUserProfile(token, userId, newFilters) {
  //Make sure profile is updated -> need latest version
  let profile = await fetchMyProfile(token);

  return await makeJsonRequest({
      generateUrl: () => `${BASE_URL_API_V2}/users/${userId}/profile`,
      generateBody: () => {
        console.log("Patching User profile: ");

        let profileFieldWrapper = {};
        profileFieldWrapper[PROFILE_FIELD_SAVED_FILTERS] = [{
          value: JSON.stringify(newFilters),
        }];

        let body = {};
        body[PROFILE_SECTION_SAVED_FILTERS] = profileFieldWrapper;

        body.version = profile.version;

        return body;
      },
      parseError: json => {
        const error = new Error(`An error occurred while trying to save the filters: ${json.message}`);
        return error;
      },
      method: "PUT",
      token: token
  });
}

export async function doDeleteUserSkills(token, skillLevels) {
  //Prepare easier structure
  let deleteList = [];

  skillLevels.forEach(changedUser => {
    if(changedUser.removedSkills) {
      changedUser.removedSkills.forEach(changedSkill => {
        deleteList.push({userId: changedUser.userId, skillId: changedSkill.id});
      })
    }
  });

  return await makeMultipleJsonRequests({
    generateUrl: removeEntry => `${BASE_URL_API_V2}/users/${removeEntry.userId}/routingskills/${removeEntry.skillId}`,
    parseError: json => {
      const error = new Error(`An error occurred while trying to patch the skill levels: ${json.message}`);
      return error;
    },
    method: "DELETE",
    token: token
  }, deleteList);
}


export async function patchLanguageLevels(token, languageLevels) {
  await doPatchLanguageLevels(token, languageLevels);
  await doDeleteUserLanguages(token, languageLevels);
}

export async function doPatchLanguageLevels(token, languageLevels) {

  return await makeMultipleJsonRequests({
    generateUrl: userLevels => `${BASE_URL_API_V2}/users/${userLevels.userId}/routinglanguages/bulk`,
    generateBody: userLevels => {
      return userLevels.skillLevels.map(skillLevel => { 
        return {
          id: skillLevel.id, 
          proficiency : skillLevel.proficiency
        };
        });
    },
    parseError: json => {
      const error = new Error(`An error occurred while trying to patch the language levels: ${json.message}`);
      return error;
    },
    method: "PATCH",
    token: token
  }, languageLevels);
}

export async function doDeleteUserLanguages(token, languageLevels) {
  //Prepare easier structure
  let deleteList = [];

  languageLevels.forEach(changedUser => {
    if(changedUser.removedSkills) {
      changedUser.removedSkills.forEach(changedSkill => {
        deleteList.push({userId: changedUser.userId, skillId: changedSkill.id});
      })
    }
  });


  return await makeMultipleJsonRequests({
    generateUrl: removeEntry => `${BASE_URL_API_V2}/users/${removeEntry.userId}/routinglanguages/${removeEntry.skillId}`,
    parseError: json => {
      const error = new Error(`An error occurred while trying to patch the language levels: ${json.message}`);
      return error;
    },
    method: "DELETE",
    token: token
  }, deleteList);
}


const getAuthenticationHeader = (token) => {
    return {
      Authorization: `bearer ${token}`,
      'content-type': 'application/json'
    }
}

const makeMultipleJsonRequests = async (config, entities) => {
  const requests = [];
  if (!entities) return;
  entities.forEach(entity => {
    if (config.validateEntity && !config.validateEntity(entity)) return;
    requests.push(getJsonPromise(config, entity));
  })

  try {
    const responses = await Promise.all(requests);
    //console.log(responses);
    return responses;
  } catch (error) {
    console.error(error);
    if (error.json) console.error(error.json);
    throw error;
  }
}

const makeJsonRequest = async (config, entity) => {
  try {
    const responses = await getJsonPromise(config, entity);
    //console.log(responses);
    return responses;
  } catch (error) {
    console.error(error);
    if (error.json) console.error(error.json);
    throw error;
  }
}

const getJsonPromise = async (config, entity) => {
  const method = config.method || "GET";
  const fetchConfig = {
    headers: getAuthenticationHeader(config.token),
    method: method,
  }

  let endResult = !config.mergeResult ? [] : null;

  let hasNextPage = true;
  let nextUri = null;

  while(hasNextPage) {
    if (method !== "GET" && config.generateBody) {
      let body = config.generateBody(entity);

      //In case of a POST (ex: /users/search) the page number needs to be in the body
      if(body && body.pageNumber){
        body.pageNumber = config.pageNumber;
      }

      fetchConfig.body = JSON.stringify(body);
    } 

    if (config.signal) {
      fetchConfig.signal = config.signal;
    }

    const url = !nextUri ? config.generateUrl(entity) : `${config.baseUrl}${nextUri}`;

    const response = await fetch (url, fetchConfig);
    //console.log("resp");
    //console.log(response);

    //avoid unnecessary json errors
    const text = await response.text();
    const hasParsedJson = text && text.length;
    let json = hasParsedJson ? JSON.parse(text) : text;

    //POST (/v2/users/search) uses nextPage instead of nextUri
    if (method === "POST"){
      hasNextPage = hasParsedJson && !!json.nextPage;
      nextUri = hasParsedJson && json.nextPage;
      //Update page number in config to make sure body is updated next with next value
      if(config.pageNumber){
        config.pageNumber++;
      }
    } else {
      hasNextPage = hasParsedJson && !!json.nextUri;
      nextUri = hasParsedJson && json.nextUri;
    }

    if (!response.ok) {
        console.error(json);
        const error = config.parseError(json, entity);
        error.json = json;
        throw error;
    }

    if (config.convertJson) json = config.convertJson(json, entity);
    if (config.mergeResult) {
      endResult = config.mergeResult(endResult, json);
    } else if (!hasNextPage) {
      endResult = json;
    } else {
      throw new Error("Please add a mergeResult function to the config. Request has multiple pages.");
    }
  }

  return endResult;
}